import React, { createContext } from 'react';

const FirebaseContext = createContext(null);

const noop = () => null;

const firebase = {
  app: null,
  database: null,
  auth: null,
  storage: null,
  authRef: noop,
  googleProvider: null,
  appleProvider: null,
  phoneProvider: null,
  RecaptchaVerifier: noop,
  signInWithPhoneNumber: noop,
  updatePhoneNumber: noop,
  unlink: noop,
  googleCredential: noop,
  linkWithPhoneNumber: noop,
  mobileAuthCredential: noop,
  usersRef: null,
  bookingRef: null,
  cancelreasonRef: null,
  settingsRef: null,
  smtpRef: null,
  carTypesRef: null,
  carTypesEditRef: noop,
  carDocImage: noop,
  promoRef: null,
  promoEditRef: noop,
  notifyRef: null,
  notifyEditRef: noop,
  addressRef: noop,
  addressEditRef: noop,
  singleUserRef: noop,
  profileImageRef: noop,
  verifyIdImageRef: noop,
  bookingImageRef: noop,
  driversRef: null,
  driverDocsRef: noop,
  driverDocsRefBack: noop,
  singleBookingRef: noop,
  requestedDriversRef: noop,
  referralIdRef: noop,
  trackingRef: noop,
  tasksRef: noop,
  singleTaskRef: noop,
  bookingListRef: noop,
  chatRef: noop,
  withdrawRef: null,
  languagesRef: null,
  languagesEditRef: noop,
  walletHistoryRef: noop,
  userNotificationsRef: noop,
  userRatingsRef: noop,
  carsRef: noop,
  carAddRef: null,
  carEditRef: noop,
  carImage: noop,
  allLocationsRef: null,
  userLocationRef: noop
};

const FirebaseProvider = ({ children }) => {
  return (
    <FirebaseContext.Provider value={firebase}>
      {children}
    </FirebaseContext.Provider>
  );
};

export {
  firebase,
  FirebaseProvider,
  FirebaseContext
};
